import {createRouter, createWebHistory} from "vue-router";
import {useAuthStore} from "../stores/auth";
import {isTokenExpired} from "../utils/jwt";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import RegisterView from "../views/RegisterView.vue";
import DashboardView from "../views/DashboardView.vue";
import AiAgentsView from "../views/AiAgentsView.vue";
import AiAgentEditView from "../views/AiAgentEditView.vue";
import KnowledgeBaseView from "../views/KnowledgeBaseView.vue";
import LeadsView from "../views/LeadsView.vue";
import ChatHistoryView from "../views/ChatHistoryView.vue";
import SettingsView from "../views/SettingsView.vue";
import AiWidgetConfigurationView from "../views/AiWidgetConfiguration.vue";
import VisitorsView from "../views/VisitorsView.vue";
import IntegrationsView from "../views/IntegrationsView.vue";

const routes = [
    {path: "/", component: HomeView},
    {path: "/login", component: LoginView, meta: {guestOnly: true}},
    {path: "/register", component: RegisterView, meta: {guestOnly: true}},
    {path: "/dashboard", component: DashboardView, meta: {requiresAuth: true}},
    {path: "/ai-agents", component: AiAgentsView, meta: {requiresAuth: true}},
    {path: "/ai-agents/:id", component: AiAgentEditView, meta: {requiresAuth: true}},
    {path: "/knowledge-base", component: KnowledgeBaseView, meta: {requiresAuth: true}},
    {path: "/leads", component: LeadsView, meta: {requiresAuth: true}},
    {path: "/chat-history", component: ChatHistoryView, meta: {requiresAuth: true}},
    {path: "/settings", component: SettingsView, meta: {requiresAuth: true}},
    {path: "/ai-widget-configuration", component: AiWidgetConfigurationView, meta: {requiresAuth: true}},
    {path: "/visitors", component: VisitorsView, meta: {requiresAuth: true}},
    {path: "/integrations", component: IntegrationsView, meta: {requiresAuth: true}},
    {path: "/:pathMatch(.*)*", redirect: "/"},
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to) => {
    const auth = useAuthStore();

    if (auth.accessToken && isTokenExpired(auth.accessToken)) {
        auth.clearSession();
    }

    if (to.meta.requiresAuth && !auth.isAuthenticated) return "/login";

    if (to.meta.guestOnly && auth.isAuthenticated) return "/dashboard";
});

export default router;
